
import { defineComponent, ref, reactive, toRefs, onMounted } from 'vue'
import { useI18n } from 'vue-i18n'
import { useRoute } from 'vue-router'
import { createModel, createModelArray } from '@/utils/component'
import { getCompanyById } from '@/apis/main-data/company'
import Container from '@/components/form/container/Container.vue'
import DynamicForm from '@/components/form/common/DynamicForm.vue'
import { CompanyBankModel, CompanyInfoModel } from '@/model/master-data/companyModel'
import { ElForm, ElMessage } from 'element-plus'

export default defineComponent({
  components: {
    Container,
    DynamicForm
  },
  setup() {
    const { t } = useI18n()
    const formRef = ref(ElForm)
    const id = useRoute().params.id.toString()
    const isDataLoaded = ref(false)
    const companyStruct = [
      { prop: 'name', label: t('company.companyName'), component: 'el-input', type: 'text', model: '' },
      { prop: 'companyCode', label: t('company.companyCode'), component: 'el-input', type: 'text', model: '' },
      { prop: 'companyBanks', label: t('bank.bankInfo'), component: 'custom-groups' }
    ]
    const bankStruct = [
      { prop: 'account', label: t('bank.bankAccount'), component: 'el-input', type: 'text', model: '' },
      { prop: 'code', label: t('bank.bankCode'), component: 'el-input', type: 'text', model: '' },
      { prop: 'name', label: t('bank.bankName'), component: 'el-input', type: 'text', model: '' },
      { prop: 'city', label: t('bank.bankCity'), component: 'el-input', type: 'text', model: '' },
      {
        prop: 'isCompanyAccount',
        label: t('order.isCompanyAccount'),
        component: 'el-radio-group',
        type: 'boolean',
        model: null,
        options: [
          { label: t('common.yes'), value: true },
          { label: t('common.no'), value: false }
        ]
      }
    ]
    const dataMap = reactive({
      formStruct: companyStruct,
      formModel: createModel(companyStruct) as CompanyInfoModel,
      groupFormStruct: bankStruct,
      groupFormModels: createModelArray(bankStruct) as CompanyBankModel[],
      async getCompanyInfo() {
        let companyId
        try {
          companyId = Number(id)
        } catch (error) {
          ElMessage({
            message: 'id 格式错误;' + id,
            type: 'error',
            duration: 2000
          })
          return
        }
        const data = await getCompanyById(companyId)
        const companyInfo = data?.data ?? null
        if (companyInfo) {
          dataMap.formModel.id = companyInfo.id
          dataMap.formModel.companyCode = companyInfo.companyCode
          dataMap.formModel.name = companyInfo.name
          dataMap.groupFormModels = companyInfo.companyBanks
          isDataLoaded.value = true
        }
      }
    })
    onMounted(() => {
      dataMap.getCompanyInfo()
    })
    return {
      t,
      formRef,
      isDataLoaded,
      ...toRefs(dataMap)
    }
  }
})
